import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { CalendarAppState } from '../classes/redux-states';
import { toggleCalendarView } from '../redux/actions/actions';

interface InternalProps {
}

interface StateToProps {
    selectedView: string;
}

interface DispatchToProps {
    toggleView: (selectedView: string) => any;
}

type CalendarToggleProps = InternalProps & StateToProps & DispatchToProps;

export class CalendarToggleComponent extends React.Component<CalendarToggleProps, null> {
    constructor(props: CalendarToggleProps) {
        super(props);
    }

    handleOptionChange(changeEvent: any) {
        this.props.toggleView(changeEvent.target.value);
    }

    render() {
        return (
            <div className="calendar-filter-view">
                <span className="calendar-filter-view-toggle">
                    <input id="grid-view" type="radio" value="grid-view" checked={this.props.selectedView === "grid-view" ? true : false} onChange={this.handleOptionChange.bind(this)} />
                    <label className="calendar-filter-view-grid" htmlFor="grid-view">
                        <svg className="svg-icon open" aria-hidden="true" focusable="false">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-grid-view" />
                        </svg>

                        Calendar
          </label>
                </span>

                <span className="calendar-filter-view-toggle">
                    <input id="list-view" type="radio" value="list-view" checked={this.props.selectedView === "list-view" ? true : false} onChange={this.handleOptionChange.bind(this)} />
                    <label className="calendar-filter-view-list" htmlFor="list-view">
                        <svg className="svg-icon open" aria-hidden="true" focusable="false">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-list-view" />
                        </svg>

                        List
          </label>
                </span>



            </div >
        )
    }
}

function mapStateToProps(state: CalendarAppState): StateToProps {
    return {
        selectedView: state.calendarApiModel.selectedView
    }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>): DispatchToProps {
    return {
        toggleView: (selectedView: string) => dispatch(toggleCalendarView(selectedView))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarToggleComponent);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-toggle.tsx